import React from 'react';
import { GovIcon, GovMessage } from '@gov-design-system-ce/react';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import { MarkdownRender } from '@gov-nx/component/web';
import type { useApplicantLoader } from '@gov-nx/core/hooks';
import { useLocale } from '@gov-nx/core/service';
import type { EPeticeFormDataStep1, PageCode } from '@gov-nx/module/page';
import {
	Button,
	ButtonGroupLayout,
	FormTextarea,
	LayoutGap,
} from '@gov-nx/ui/web';
import { FounderSelect } from './FounderSelect';

interface WizardStep1Props {
	code: PageCode;
	formDefinition: FormDefinition<EPeticeFormDataStep1>;
	isLoading: boolean;
	isDisabled: boolean;
	applicant: ReturnType<typeof useApplicantLoader>;
}

export const WizardStep1 = ({
	code,
	formDefinition,
	isDisabled,
	isLoading,
	applicant,
}: WizardStep1Props) => {
	const { t } = useLocale(code);

	return (
		<LayoutGap gap="xl">
			<LayoutGap gap="m">
				<h2 className="text-headline-m!">
					{t('formular.nadpis.nazev-epetice')}
				</h2>
				<FormTextarea
					label={{ children: t('formular.pole.nazev') }}
					field={{
						name: 'nazev',
						rows: 3,
						isDisabled,
						placeholder: t('formular.placeholder.nazev'),
					}}
				/>
			</LayoutGap>

			<LayoutGap gap="m">
				<h2 className="text-headline-m!">
					{t('formular.nadpis.udaje-zakladateli')}
				</h2>

				<FounderSelect
					code={code}
					isDisabled={isDisabled}
					applicant={applicant}
					formDefinition={formDefinition}
				/>
			</LayoutGap>

			<LayoutGap gap="m">
				<GovMessage
					color="primary"
					type="subtle"
					icon={
						<GovIcon
							type="components"
							name="lightbulb-fill"
						/>
					}>
					<MarkdownRender>
						{t('formular.zprava.info-zakladatel-typ')}
					</MarkdownRender>
				</GovMessage>
			</LayoutGap>

			<ButtonGroupLayout>
				<Button
					isLoading={isLoading}
					aria-label={t('akce.wcag.pokracovat')}
					isDisabled={isDisabled}
					nativeType="submit"
					color="primary"
					size="l"
					type="solid">
					{t('formular.tlacitko.pokracovat')}
				</Button>
			</ButtonGroupLayout>
		</LayoutGap>
	);
};
